export default __webpack_public_path__ + "static/media/atualizacao-02.b0971b79.svg";